// extracted by mini-css-extract-plugin
module.exports = {"root":"_2YyJk","header":"_3FLCC","title":"VSO4u","cta":"_1dAAS","ctaIcon":"_2ETHq","itemsWrapper":"_2fSmH","subtitle":"_3bx9n","ctaTitle":"_2mLf9"};